import React from 'react';
import { ITextMessage } from './types';

export function TextMessage({
	message,
}: {
    message: ITextMessage;
}): JSX.Element {
	// eslint-disable-next-line react/jsx-no-useless-fragment
	return <>{message.text}</>;
}
